import { Injectable } from '@angular/core';

import { PlacementErrorType } from '@frontend/sports/types/betslip';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatLatestFrom } from '@ngrx/operators';
import { Store } from '@ngrx/store';
import { mergeMap } from 'rxjs';

import { selectIsLinearBetslip } from '../../../base/store/selectors';
import { IBetslipRootState } from '../../../base/store/state';
import { BetslipV2HorseRaceXCastPick } from '../../../core/picks/sport-specific/betslip-v2-horse-race-picks';
import { OverAskBetslipError } from '../../../model/over-ask/over-ask';
import { BetslipTypesActions } from '../../types/actions';
import BetslipErrorsActions from '../../validation/actions';
import { OverAskError } from '../../validation/errors/over-ask/over-ask.error';
import { BetslipOverAskActions } from '../actions';
import { overAskStateSelector } from '../selectors';

@Injectable()
export class DigitalOverAskEffects {
    constructor(
        private actions$: Actions,
        private store: Store<IBetslipRootState>,
    ) {}

    handleError$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(BetslipOverAskActions.addError),
            concatLatestFrom(() => [this.store.select(overAskStateSelector), this.store.select(selectIsLinearBetslip)]),
            mergeMap(([action, overAskState, isLinear]) => {
                const actions = [BetslipErrorsActions.cleanManualRemoveErrors()];
                const newStakeHint = overAskState.error.newStakeHint || 0;

                if (newStakeHint > 0) {
                    const hasAnyCombinationalXCast = overAskState.bets
                        .flatMap((bet) => bet.picks)
                        .some((pick) => BetslipV2HorseRaceXCastPick.isPick(pick.pick) && pick.pick.betCount() > 1);

                    if (action.error === OverAskBetslipError.OfferRejected && !hasAnyCombinationalXCast) {
                        if (!isLinear) {
                            actions.push(BetslipTypesActions.setStake({ stake: newStakeHint, silent: true }));
                        } else {
                            actions.push(
                                ...overAskState.bets.map((bet) =>
                                    BetslipErrorsActions.setStakeFromSlipStakeHint({
                                        slipStakeHint: {
                                            newStakeHint,
                                            slipId: bet.slipId,
                                            // setting a fake error type as its not user later
                                            type: PlacementErrorType.OverAskOfferError,
                                        },
                                    }),
                                ),
                            );
                        }
                    }
                }

                actions.push(BetslipErrorsActions.addBetslipError({ error: new OverAskError(action.error, overAskState.error.newStakeHint) }));

                return actions;
            }),
        );
    });
}
